import * as React from "react"

const CheckCircledFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1ZM6.728 9.517 4.757 7.422 4 8.127 6.703 11 12 5.73 11.268 5l-4.54 4.517Z" />
  </svg>
)

export default CheckCircledFilled
